module.exports = __webpack_public_path__ + "img/myles.07818b30.jpeg";